/** Created by azhou on 2019/4/9.*/
<template>
    <div>
      <ul class="list-head mt-3"><li class="w-50" v-for="item in titleArr" :key="item">{{item}}</li></ul>
      <ul class="list-item" v-for="item in highLevelUser" :key="item.id">
        <li class="w-50 list-item-col">{{item.truename}}</li>
        <li class="w-50 list-item-col"  :class="$GFUN.userColor(item.type)">{{item.level | formatVar('userLevel')}}</li>
        <li class="w-50 list-item-col">{{item.mobile}}</li>
        <li class="w-50 list-item-col" :class="item.wechat_openid!=item.uid ? 'text-success' : 'text-danger'">
          {{item.wechat_openid!=item.uid? '已绑定' : '未绑定'}}
        </li>
        <li class="w-50 list-item-col">{{item.num}}</li>
        <li class="w-50 list-item-col">{{item.login_time | formatTimestamp(1)}}</li>
        <li class="w-50 list-item-col-end flex-wrap">
          <span class="text-link mr-2" @click="checkDetail(item)">查看更多</span>
          <!-- <span class="text-link" @click="editUser(item)">编辑</span> -->
        </li>
      </ul>
      <el-dialog title="用户详情" :visible.sync="showDetail" center :show-close="false">
        <div class="d-flex flex-wrap">
          <div class="d-center-start w-50 mb-3" v-for="item in showDetailArr" :key="item.name">
            <left-text :leftText="item.name"/><span v-html="currentItem[item.value]"></span>
          </div>
          <div class="d-center-start w-50 mb-3">
            <left-text leftText="账号密码"/>
            <span v-show="showPassword" class="mr-2">{{currentItem.password}}</span>
            <i class="iconfont text-link" @click="showPassword = !showPassword"
               :class="[showPassword ? 'icon-yanjing-zheng' : 'icon-yanjing-bi']"></i>
          </div>
        </div>
        <el-button slot="footer" type="primary" @click="showDetail = false">确 定</el-button>
      </el-dialog>
    </div>
</template>

<script>
  import { mapGetters, mapState,mapActions} from 'vuex'

  export default {
    name: 'UserArr',
    computed: {
      ...mapState(['StoreBasicInfo','AdminDataDetail']),
      ...mapGetters(['storeInfo']),
            // 只返回 level > 2 的用户
      highLevelUser() {
        return this.StoreBasicInfo.userArr.filter(item => item.level > 2);
      }
    },
    data() {
      return {
        titleArr:['用户名','用户级别','手机号','微信','登录次数','上次登录时间','操作'],
        currentItem:{},
        showDetail:false,
        showPassword:false,
        showDetailArr:[
          {name:'用户姓名',value:'truename'},{name:'注册来源',value:'trace'},{name:'用户级别',value:'level'},
          {name:'上次登录时间',value:'login_time'},{name:'手机号',value:'mobile'},
          {name:'绑定微信',value:'wechat_openid'},{name:'注册时间',value:'reg_time'},{name:'登录次数',value:'num'},
          {name:'企业账号',value:'username'}
        ],
      }
    },
    methods:{
      ...mapActions(['getAdminDataLists','getItemDetail']),
      async checkDetail(item) {
        await this.getItemDetail({
          type:'userDetail',
          data:{
            uid:item.uid,
            // store_type:item.type
          }
        })
        this.currentItem = {
          ...this.AdminDataDetail,
          wechat_openid:` ${item.wechat_openid!=item.uid ? '已绑定' : '未绑定'}`,
          level:this.$options.filters['formatVar'](item.level,'userLevel'),
          trace:this.$options.filters['formatVar'](this.AdminDataDetail.trace,'traces'),
          login_time:item.login_time > 0 ? this.$options.filters['formatTimestamp'](item.login_time,1) : '从未登录',
          reg_time:this.$options.filters['formatTimestamp'](this.AdminDataDetail.reg_time,1)
        };
        this.showDetail = true;
      },
      editUser(item) {
        let {id,truename,mobile,status,wechat_openid,type} = item;
        this.$router.push({name:'editUser',query:{id,truename,mobile,status,wechat_openid,type}})
      }
    }
  }
</script>
